import React from "react";

import PillSkeleton from "./PillSkeleton";

const SuggestionSkeleton = () => {
  return (
    <div>
      <div className="mb-3 h-5 w-28 rounded-md bg-gray-300"></div>
      <PillSkeleton length={5} />
    </div>
  );
};

export default SuggestionSkeleton;
